import * as z from "zod";
// --- Zod Schemas ---

export const CardSchema = z.object({
    title: z.string(),
    body: z.string(),
});

export const DiscountSchema = z.object({
    valor: z.number(),
    tipo: z.enum(["Porcentaje", "Fijo"]),
    lugares: z.array(z.enum(["Cajas", "Envio", "Upsell"])),
    cantidad: z.number(),
});

export const GiftSchema = z.object({
    card: CardSchema,
    aceptacion: CardSchema,
    // descuentos: z.array(DiscountSchema), // Comentado como en el original
});

export const SuscriptionScheme = z.object({
    user: z.string(),
});

export const ReasonSchema = z.object({
    razon: CardSchema,
    tags: z.array(z.string()),
    regalo: GiftSchema.optional(),
    cancelar: CardSchema,
});

export const ReasonCategorySchema = z.object({
    base: z.string(),
    reasones: z.array(ReasonSchema),
});

export const ReasonsToLeaveApiResponseSchema = z.object({
    reasons: z.array(ReasonCategorySchema),
});

export const CancelSubscriptionFormSchema = z
    .object({
        user_action: z.string(),
        termination_comments: z.string().optional(),
        termination_main_reason: z.string({
            required_error:
                "⚠️ Por favor selecciona una opción. Nos ayudaría a mejorar.",
        }),
        termination_reason: z.string({
            required_error:
                "⚠️ Por favor selecciona una opción. Nos ayudaría a mejorar.",
        }),
        selected_tags: z.array(z.string()).optional(),
    })
    .superRefine((data, ctx) => {
        if (
            (!data.termination_comments ||
                data.termination_comments.trim() === "") &&
            (!data.selected_tags || data.selected_tags.length === 0)
        ) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ["termination_comments"],
                message:
                    "⚠️ Por favor, déjanos un comentario o selecciona al menos un tag para ayudarnos a mejorar.",
            });
        }
    });

// --- Inferred Types ---

export type Card = z.infer<typeof CardSchema>;
export type Discount = z.infer<typeof DiscountSchema>;
export type Gift = z.infer<typeof GiftSchema>;
export type Reason = z.infer<typeof ReasonSchema>;
export type ReasonCategory = z.infer<typeof ReasonCategorySchema>;
export type ReasonsToLeaveApiResponse = z.infer<
    typeof ReasonsToLeaveApiResponseSchema
>;
export type CancelSubscriptionFormValues = z.infer<
    typeof CancelSubscriptionFormSchema
>;
